module.exports = __webpack_public_path__ + "diamo2.jpg?bc428c91b8f86653b9606c089a592da9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/diamo2.jpg
// module id = 228
// module chunks = 0